// @ts-expect-error - useTextDetectedBrandTermsDebounced has no TypeScript declarations
import { useTextDetectedBrandTermsDebounced } from 'src/services/useTextDetectedBrandTermsDebounced';
// @ts-expect-error - brand terms store has no TypeScript declarations
import { useBrandVoiceIdsForBrandTerms } from 'src/store/brandTerms/useBrandVoiceIdsForBrandTerms';

import { LONG_FORM_INSIGHTS_DEBOUNCE_TIMEOUT } from './longFormConst';

interface Params {
  /** Bumped when the panel is re-seeded, so a stale request cannot land on the new content. */
  key: number;
  text: string;
}

export const useLongFormDetectedBrandTermsData = ({ key, text }: Params) => {
  const { brandVoiceIdsForBrandTerms } = useBrandVoiceIdsForBrandTerms();

  return useTextDetectedBrandTermsDebounced(
    { key, brandVoiceIds: brandVoiceIdsForBrandTerms, text },
    { debounceTimeout: LONG_FORM_INSIGHTS_DEBOUNCE_TIMEOUT }
  );
};
